/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import React from "react";
import Navbar from "react-bootstrap/Navbar";

import { useIsAuthenticated } from "@azure/msal-react";
import { SignInButton } from "./SignInButton";
import { SignOutButton } from "./SignOutButton";

/**
 * Renders the navbar component with a sign-in or sign-out button depending on whether or not a user is authenticated
 * @param props
 */
export const PreAuthenticationPage = (props: any) => {

  const isAuthenticated = useIsAuthenticated();
  return (
    <>
      <Navbar bg="primary" className="App-navbar">
        Welcome to Contacts Manager from 365Apps
        <Navbar.Collapse className="justify-content-end">
          <Navbar.Text>
            {isAuthenticated ?
              <SignOutButton />
              :
              <div
              className="signinText"
              >
                <div  className="signinText">
                  Please sign in to continue
                </div>
                <div  className="signinText">
                  A Popup window will appear for you to sign in
                </div>
                <div  className="signinText">
                <SignInButton />
                </div>
              </div>
            }

          </Navbar.Text>
        </Navbar.Collapse>
      </Navbar>

      <br />
      <br />
      {props.children}
    </>
  );
};
